import clsx from "clsx";

import { CSSProperties, ElementType } from "react";

import tokens from "@sikt/sds-tokens";

import ComponentAs, {
  ComponentAsProps,
} from "@/src/components/component-as/component-as";

import css from "./flex.module.css";

export type FlexGap = keyof typeof tokens.space.gap;

type FlexProps<T extends ElementType> = {
  alignItems?: CSSProperties["alignItems"];
  flexBasis?: CSSProperties["flexBasis"];
  flexDirection?: CSSProperties["flexDirection"];
  flexGrow?: CSSProperties["flexGrow"];
  flexShrink?: CSSProperties["flexShrink"];
  flexWrap?: CSSProperties["flexWrap"];
  fullWidth?: boolean;
  gap?: FlexGap | 0;
  gapColumn?: FlexGap | 0;
  gapRow?: FlexGap | 0;
  justifyContent?: CSSProperties["justifyContent"];
} & ComponentAsProps<T>;

export const Flex = <T extends ElementType>({
  alignItems,
  children,
  className,
  flexDirection,
  gap,
  justifyContent,
  flexWrap,
  fullWidth,
  gapRow,
  gapColumn,
  flexGrow,
  flexShrink,
  flexBasis,
  style,
  ...rest
}: FlexProps<T>) => (
  <ComponentAs
    className={clsx(
      css.flex,
      className,
      gap && css[`gap-${gap}`],
      gapRow && css[`gapRow-${gapRow}`],
      gapColumn && css[`gapColumn-${gapColumn}`],
      fullWidth && css.fullWidth,
    )}
    style={{
      ...style,
      flexGrow,
      justifyContent,
      flexWrap,
      alignItems,
      flexDirection,
      flexShrink,
      flexBasis,
    }}
    {...rest}
  >
    {children}
  </ComponentAs>
);
